import { useEffect } from "react";
import Modal from "../../../elements/Modal";
import Input from "../../../form/Input";
import Form from "../../../form/Form";
import Checkbox from "../../../form/Checkbox";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { useMutation, useQuery } from "@tanstack/react-query";
import { invitation, invitationEdit, rolePermissionList } from "../../../../services/organizationService";
import { useSelector } from "react-redux";

const validation = {
  email: { required: true, message: "Please enter your email!" },
  role: { required: true, message: "Please select role!" },
};

const user_type = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Staff",
    value: "staff",
  },
  // {
  //   label: "Promoter",
  //   value: "promoter",
  // },
];

const ManageInviteTeammate = ({ open = false, onClose = () => {}, getResponse = () => {}, data }) => {
  const { selectedOrganization, organizations } = useSelector((state) => state?.organization);
  const { values, handleChange, handleSubmit, errors, setFieldsValue, formValidate, resetField } = useForm({
    validationRules: validation,
    initialState: { role: "staff" },
  });

  useEffect(() => {
    if (values?.role === "admin") {
      setFieldsValue({ permission: [] });
    }
  }, [values?.role]);

  function onCloseHandler() {
    onClose(false);
    resetField({});
    setFieldsValue({
      role: "staff",
    });
  }

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        email: data?.userData?.email,
        role: data?.role,
        permission: data?.permission,
      });
    }
  }, [data]);

  const { data: rolesData, isLoading } = useQuery({
    queryKey: ["roles"],
    queryFn: async () => {
      const res = await rolePermissionList();
      return res?.docs;
    },
  });

  const { mutate: onSubmit, isPending } = useMutation({
    mutationFn: async (value) => {
      const payload = {
        emails: [value?.email],
        role: value?.role,
        organization: selectedOrganization,
        permission: value?.permission,
        ...(data?._id && { id: data?._id }),
      };
      if (data?._id) {
        const res = await invitationEdit(payload);
        return res;
      } else {
        const res = await invitation(payload);
        return res;
      }
    },
    onSuccess: (res) => {
      getResponse(res);
      setFieldsValue({ email: "" });
    },
  });

  return (
    <Modal isOpen={open} setIsOpen={onCloseHandler} title={"Team access"} size="md">
      <Form handleSubmit={handleSubmit} onSubmit={onSubmit}>
        <div className="space-y-5 divide-y">
          <div className="flex gap-2">
            <Input
              inputType="email"
              inputPlaceholder={"Enter email"}
              label={"Email"}
              inputName={"email"}
              onChange={(e) => {
                if (!data?._id) {
                  handleChange(e);
                }
              }}
              value={values?.email}
              {...(data?._id && { isDisabled: true })}
              {...formValidate(errors, "email")}
            />
            {/* <div className="w-52">
              <Select
                label={"Roles"}
                placeholder={"select role"}
                dropdownData={roles}
                onChange={(val) => {
                  handleChange({ target: { name: "role", value: val } });
                }}
                selectedValue={values?.role}
                {...formValidate(errors, "role")}
              />
            </div> */}
          </div>
          <div className="pt-5 space-y-3">
            {user_type?.map((type, index) => (
              <Checkbox
                key={index}
                checkboxLabel={<div className="font-medium">{type?.label}</div>}
                checked={values?.role === type?.value}
                value={type?.value}
                checkboxName={"role"}
                onChange={(e) => {
                  handleChange({
                    target: { name: e.target.name, value: e.target.value },
                  });
                }}
              />
            ))}
            {/* {values?.role === "staff" && (
              <div className="space-y-5">
                {rolesData?.data?.map((role, i) => (
                  <div key={role?._id} className="space-y-2">
                    <div>{lngDetect(role?.name)}</div>
                    <ul className="flex gap-3 items-center">
                      {role?.permission
                        ?.filter(
                          (permission) => permission?.status === "active"
                        )
                        ?.map((permission, j) => (
                          <li key={permission?._id} className="ml-0">
                            <Checkbox
                              value={permission?.code}
                              checkboxName={"permission"}
                              checked={(values?.permission || []).includes(
                                permission?.code
                              )}
                              checkboxLabel={
                                <div className="font-medium">
                                  {lngDetect(permission?.name)}
                                </div>
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setFieldsValue({
                                    [e.target.name]: [
                                      ...(values[e.target.name] || []),
                                      e.target.value,
                                    ],
                                  });
                                } else {
                                  setFieldsValue({
                                    [e.target.name]: [
                                      ...(values[e.target.name] || [])?.filter(
                                        (item) => item !== e.target.value
                                      ),
                                    ],
                                  });
                                }
                              }}
                            />
                          </li>
                        ))}
                    </ul>
                  </div>
                ))}
              </div>
            )} */}
          </div>
        </div>
        <Button
          buttonLabel={"Save"}
          buttonType="submit"
          {...(isPending && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </Form>
    </Modal>
  );
};

export default ManageInviteTeammate;
